import React from "react";
import BrandLogo from "@/components/brand/BrandLogo";

export default function ProductMockWindow({ url, activeNav = "Care", children, footer }) {
  const nav = ["Home", "Hospitals", "Care", "Profile"];

  return (
    <div className="eh-window">
      <div className="eh-window-chrome">
        <span className="eh-window-dots" aria-hidden="true">
          <i /><i /><i />
        </span>
        <div className="eh-window-url">{url}</div>
      </div>
      <div className="eh-window-nav">
        <BrandLogo className="eh-window-brand" size="sm" as="span" />
        {nav.map((item) => (
          <span key={item} className={item === activeNav ? "is-active" : undefined}>
            {item}
          </span>
        ))}
      </div>
      <div className="eh-window-body">{children}</div>
      {footer ? <div className="eh-window-footer">{footer}</div> : null}
    </div>
  );
}
